export const capitalizeString = (str: string) => {
    switch (str) {
        case 'wSeq':
        case 'rSeq':
            return str;
        default:
            return str && str[0].toUpperCase() + str.slice(1);
    }
};

export const defineIsSessionManager = (): boolean => {
    // return false
    const url = window.location.hostname

    if (url.startsWith('fixparser')) {
        return false
    }
    return true
}